module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Range-hood-40e7a1c25c46e1f25eb678a48bd6ea4c.svg";